import { numberHelpers } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { useGetRecognizedOcrAttachment } from 'pages/requestForm/hooks/useGetRecognizedOcrAttachment';
import { useOcrData } from 'pages/requestForm/hooks/useOcrData';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';

import { useCurrencyPrecision } from '../../hooks';
import { NetSuiteRequestItemsSummaryProps } from './NetSuiteRequestItemsSummary.types';

export const useRequestItemsSummary = (props: NetSuiteRequestItemsSummaryProps) => {
    const { netAmount, taxAmount, totalAmount, currency } = props;

    const request = useSelector(requestSelector);

    const ocrAttachment = useGetRecognizedOcrAttachment(request);

    const { data: ocrData } = useOcrData(request, ocrAttachment?.id);

    const currencyPrecision = useCurrencyPrecision(currency);

    const showSubtotalWarning = Boolean(ocrData?.document?.subTotal && netAmount !== ocrData.document.subTotal);
    const showTaxTotalWarning =
        numberHelpers.isNumber(ocrData?.document?.totalTax) && taxAmount !== ocrData.document.totalTax;
    const showTotalWarning = Boolean(ocrData?.document?.total && totalAmount !== ocrData.document.total);

    const currencyName = currency?.text ?? '';

    return {
        ocrData,
        currency: currencyName,
        currencyPrecision,
        showTaxTotalWarning,
        showSubtotalWarning,
        showTotalWarning,
    };
};
